<div class="layout-topbar">
    <div class="layout-topbar-logo-container">
        <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
            <i class="pi pi-bars"></i>
        </button>
        <a class="layout-topbar-logo" href="https://www.runeandgear.com">
            <img style="width:64px;height:64px" src="assets/runeandgear_logos/512hexagonlight.png" alt="logo">
            <span><img style="height:64px" src="assets/runeandgear_logos/runeandgearprecedencelight.png" alt="Rune and Gear"/></span>
        </a>
    </div>

    <div class="layout-topbar-actions">
        <div class="layout-config-menu">
            <p-menu #profileMenu [model]="profileMenuItems" [popup]="true" styleClass="layout-topbar-profile"></p-menu>
            @if (documentService.selectedProject && isEditMode()) {
                <button type="button" pTooltip="Switch to Project Mode" class="layout-topbar-action" (click)="dataService.switchToBaseLayout()">
                    <i class="pi pi-objects-column"></i>
                    <span>Edit Mode</span>
                </button>
            }
            @if (documentService.selectedProject && !isEditMode()) {
                <button type="button" pTooltip="Switch to Editor Mode" class="layout-topbar-action" (click)="dataService.switchToEditLayout()">
                    <i class="pi pi-pen-to-square"></i>
                    <span>Project Mode</span>
                </button>
            }
            <button type="button" class="layout-topbar-action" (click)="toggleDarkMode()">
                <i class="pi" [class]="{ 'pi-moon': layoutService.isDarkTheme(), 'pi-sun': !layoutService.isDarkTheme() }"></i>
            </button>
            <div class="relative">
                <button
                    class="layout-topbar-action layout-topbar-action-highlight"
                    pStyleClass="@next"
                    enterFromClass="hidden"
                    enterActiveClass="animate-scalein"
                    leaveToClass="hidden"
                    leaveActiveClass="animate-fadeout"
                    [hideOnOutsideClick]="true"
                >
                    <i class="pi pi-palette"></i>
                </button>
                <app-configurator />
            </div>
        </div>

        <button class="layout-topbar-menu-button layout-topbar-action" pStyleClass="@next" enterFromClass="hidden" enterActiveClass="animate-scalein" leaveToClass="hidden" leaveActiveClass="animate-fadeout" [hideOnOutsideClick]="true">
            <i class="pi pi-ellipsis-v"></i>
        </button>

        <div class="layout-topbar-menu hidden lg:block">
            <div class="layout-topbar-menu-content">
                <button type="button" class="layout-topbar-action">
                    <i class="pi pi-calendar"></i>
                    <span>Calendar</span>
                </button>
                <button type="button" class="layout-topbar-action">
                    <i class="pi pi-inbox"></i>
                    <span>Messages</span>
                </button>
                
                <button type="button" class="layout-topbar-action" (click)="profileMenu.toggle($event)">
                    <i class="pi pi-user"></i>
                    <span>Profile</span>
                </button>
            </div>
        </div>
    </div>
</div>
